var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-helper-wrapper" }, [
    _c("div", { staticClass: "template-helper" }, [
      _c("div", { staticClass: "template-helper__wrapper" }, [
        _c(
          "div",
          [
            _c("div", { staticClass: "template-helper-header" }, [
              _vm._v("Переменные")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "template-helper__variable" }, [
              _c(
                "span",
                {
                  directives: [{ name: "copy", rawName: "v-copy" }],
                  staticClass: "inline-code"
                },
                [_vm._v("[id]")]
              ),
              _vm._v(" - номер заяки\n\t\t\t\t")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "template-helper__variable" }, [
              _c(
                "span",
                {
                  directives: [{ name: "copy", rawName: "v-copy" }],
                  staticClass: "inline-code"
                },
                [_vm._v("[site_url]")]
              ),
              _vm._v(" - URL сайта\n\t\t\t\t")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "template-helper__variable" }, [
              _c(
                "span",
                {
                  directives: [{ name: "copy", rawName: "v-copy" }],
                  staticClass: "inline-code"
                },
                [_vm._v("[region]")]
              ),
              _vm._v(" - регион\n\t\t\t\t")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "template-helper__variable" }, [
              _c(
                "span",
                {
                  directives: [{ name: "copy", rawName: "v-copy" }],
                  staticClass: "inline-code"
                },
                [_vm._v("[city]")]
              ),
              _vm._v(" - город\n\t\t\t\t")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "template-helper__variable" }, [
              _c(
                "span",
                {
                  directives: [{ name: "copy", rawName: "v-copy" }],
                  staticClass: "inline-code"
                },
                [_vm._v("[site_name]")]
              ),
              _vm._v(" - название сайта\n\t\t\t\t")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "template-helper__variable" }, [
              _c(
                "span",
                {
                  directives: [{ name: "copy", rawName: "v-copy" }],
                  staticClass: "inline-code"
                },
                [_vm._v("[url]")]
              ),
              _vm._v(" - страница, с которой была оформлена заявка\n\t\t\t\t")
            ]),
            _vm._v(" "),
            _vm._l(_vm.settings.form_fields, function(val, index) {
              return !!_vm.fieldsName[val.type]
                ? _c(
                    "div",
                    { key: index, staticClass: "template-helper__variable" },
                    [
                      _c(
                        "span",
                        {
                          directives: [{ name: "copy", rawName: "v-copy" }],
                          staticClass: "inline-code"
                        },
                        [_vm._v("[" + _vm._s(val.type) + "]")]
                      ),
                      _vm._v(
                        " - " + _vm._s(_vm.fieldsName[val.type]) + "\n\t\t\t\t"
                      )
                    ]
                  )
                : _vm._e()
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-118d7103", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-118d7103","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/notification/HotVar.vue
// module id = 146
// module chunks = 0